const netErrors = ["type error", "network error", "failed to fetch"];

export const parseErrorMessage = (error: string) =>
  netErrors.some(netErr => error.toLowerCase().includes(netErr))
    ? "Internet Connection Failed"
    : error;
